// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2LIAS","title":"AfterFrontImage_title__1M44B"};